import '../../../../node_modules/mark.js/dist/jquery.mark';

var headerHeight = $('#header').outerHeight();
function markHighlight() {
  var options = {
    "separateWordSearch": true,
    "className": "highlightMark",
    "done": function() {
      if ($('.highlightMark').parents('.jsAccordionBox').is(":hidden")) {
        $('.highlightMark').parents('.jsAccordionBox').slideDown(200).prev('.jsAccordion').addClass('active');
      }
    },
  }
  var $input = $("input[name='keywordMark']"),
    $context = $(".faqContentBox"),
    $form = document.getElementById('formSearch'),
    $results,
    currentClass = "current",
    offsetTop = headerHeight + $('.faqSearchBox').innerHeight() + 100,
    currentIndex = 0;

  function jumpTo() {
    if ($results.length) {
      var position,
        $current = $results.eq(currentIndex - 1);
      $results.removeClass(currentClass);
      if ($current.length) {
        $current.addClass(currentClass);
        position = $current.offset().top - offsetTop;
        window.scrollTo(0, position);
      }
    }
  }

  $input.on("input", function() {
    if ($(this).val().length > 0) {
      $(this).parents('.faqSearchInput').find('.jsRmVal').show();
    } else {
      $(this).parents('.faqSearchInput').find('.jsRmVal').hide();
    }
  });

  $input.bind("paste", function() {
    $(this).parents('.faqSearchInput').find('.jsRmVal').show();
  });

  $(".jsRmVal").on("click", function() {
    $input.val('');
    $(this).hide();
    $('.highlightMark').parents('.jsAccordionBox').slideUp(200).prev('.jsAccordion').removeClass('active');
    $context.unmark();
  });
  if ($form) {
    $form.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) {
        $results = $context.find("mark");
        if ($results.length) {
          currentIndex += 1;
          if (currentIndex > $results.length - 1) {
            currentIndex = 0;
          }
          jumpTo();
        }
      }
    });
  }
  $(".jsMark").on("click", function() {
    var term = $input.val();
    $('.highlightMark').parents('.jsAccordionBox').slideUp(200).prev('.jsAccordion').removeClass('active');
    $context.unmark();
    if (term) {
      $context.mark(term, options);
    }
  });
}

window.addEventListener('load', function(e) {
  headerHeight = $('#header').outerHeight();
  markHighlight();
});

window.addEventListener('resize', function(e) {
  headerHeight = $('#header').outerHeight();
});